import Taro from '@tarojs/taro';

const useDidHide = (callback: () => any) => {
  try {
    Taro.useDidHide(callback);
  } catch (error) {
    // do nothing
  }
};

export default useDidHide;
